module.exports = __webpack_public_path__ + "public/images/orange-star.11d955eb07b39071d0cd5fe99ba75f0e.webp";